import { useCoreStore } from '../../stores/core';
import { ICommand } from '../contracts/ICommand';

export class RepeatCommand implements ICommand {
  async execute(): Promise<void> {
    useCoreStore.getState().htCoreManager.repeat();
  }
}
